import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { utils, translate } from 'parking-react-common'

import { isEmpty } from 'lodash'

import { api, invoices, users, parkingLots, filters } from '../redux'

import List from '../components/List'
import UserDisplay from '../components/UserDisplay'
import TZDateTime from './TZDateTime'
import ListTotals from './ListTotals'

const InvoicesList = ({ dataSelector, dataURL, dispatch, t }) => {
    const columns = [
        {
            key    : 'series',
            title  : t('Series'),
            render : ({ rowData }) => invoices.series(rowData)
        },
        {
            key    : 'total',
            title  : t('Total'),
            parse  : ({ cellData }) => parseFloat(cellData),
            render : ({ cellData, rowData }) => utils.formatAmountWithUnit(cellData, rowData.currency),
            total  : (data) => <ListTotals field="total" unitField="currency" data={ data } />
        },
        {
            key    : 'moment',
            title  : t('Moment'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key    : 'customer',
            title  : t('Customer'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ cellData } />
            )
        },
        {
            key    : 'company',
            title  : t('Company'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <div>
                    { !isEmpty(cellData.name) && [<strong>{ cellData.name }</strong>, <br />] }
                    { !isEmpty(cellData.address) && [<span>{ cellData.address }</span>, <br />] }
                    { !isEmpty(cellData.phone) && [<span>{ cellData.phone }</span>, <br />] }
                    { !isEmpty(cellData.bank_account) && [<span>{ cellData.bank_account }</span>, <br />] }
                    { !isEmpty(cellData.bank_name) && [<span>{ cellData.bank_name }</span>, <br />] }
                </div>
            )
        }
    ]

    const searchKeys = ['parking_lot.name', ...invoices.getSearchKeys(), ...users.getSearchKeys('customer')]
    const filterKeys = {
        moment: filters.TYPES.dateRange
    }

    return (
        <List
            title={ t('Invoices') }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
            sortBy="moment"
            isDownloadable
            isMassDownloadable
            onRowClick={ ({ rowData }) => {
                dispatch(api.download(rowData.url, { format: 'pdf' }, `invoice-${invoices.series(rowData)}.pdf`))
            } }
        />
    )
}

InvoicesList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

InvoicesList.defaultProps = {
    dataSelector : invoices.getAll,
    dataURL      : 'invoices'
}

function mapStateToProps(state, ownProps) {
    const dataSelector = (state) => {
        const invoices = ownProps.dataSelector(state)
        return utils.enhance(invoices, {
            parking_lot : (payment) => parkingLots.getForID(payment.parking_lot)(state),
            user        : (payment) => users.getForID(payment.user)(state)
        })
    }

    return {
        dataSelector
    }
}


export default translate()(connect(mapStateToProps)(InvoicesList))
